/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.membership.levels.create.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.calendar',
  'acme.common.service.userPreferences',
  'acme.common.service.permissions',
  'acme.common.service.viewState',
  'acme.common.service.themesHelper',
  'acme.common.factory.notice',
  'acme.common.factory.salesChannels',
  'acme.common.directive.fieldFocus',
  'acme.view.application.membership.offerings.controllers',
  'acme.view.application.membership.benefits.modals.add.controllers',
  'acme.view.application.membership.levels.create.modals.remove.controllers'
])

.controller('MembershipLevelsCreateController', ['$scope', '$state', '$uibModal', '$filter', '$timeout', 
  'ApiService', 
  'HelpersService', 
  'CalendarService', 
  'UserPreferencesService', 
  'NoticeFactory', 
  'SalesChannelsFactory', 
  'PermissionsService', 
  'ViewStateService', 
  'MembershipLevelCollections',
  'ThemesHelperService',
  function($scope, $state, $uibModal, $filter, $timeout, 
  ApiService, 
  HelpersService, 
  CalendarService, 
  UserPreferencesService, 
  NoticeFactory, 
  SalesChannelsFactory, 
  PermissionsService, 
  ViewStateService,
  MembershipLevelCollections,
  ThemesHelperService) {

    $scope.membershipLevelsCreate = {

      model: {
        name: '',
        membershipLevelGroup: 'organization',
        rules: {
          canGift: true,
          startBeginningOfMonth: false,
          expireEndOfMonth:   false,
          numberOfCardHolders: 0
        },
        auxiliary: false,
        membershipLevelCollection: []
      },
      mode: 'create',
      levelId: '',
      tab: 'description',
      notice: new NoticeFactory(),
      company: ThemesHelperService.getCompany(),
      profileImageUploadStatus: 'Change',
      lastUpdated: '',
      lastPublished: '',
      addOrgCardholder: false,
      numberOfCardHolders: 0,
      descriptionRemaining: 300,
      descriptionMax: 300,

      addModal: false,
      removeModal: false,
      isSubmitted: false,
      isLoadingImage: false,
      categoryId: '',
      isGroupIndividualFamily: false,
      isRegular: true,
      isAuxiliaryMembershipEnabled: false,

      summernoteConfig: {
        height: 300,
        focus: false,
        shortcuts: false,
        toolbar: [
          ['style', ['bold', 'italic', 'underline', 'clear']],
          ['fontsize', ['fontsize']],
          ['color', ['color']],
          ['para', ['ul', 'ol', 'paragraph']],
          ['height', ['height']]
        ]
      },
      membershipLevelCollection: [],
      selectedMembershipLevelCollection: {},

      dateFormat: UserPreferencesService.getDateFormat('standardDate', 'dateFormat'),
      hourFormat: UserPreferencesService.getDateFormat('standardTime', 'hourFormat'),

      init: function() {
                
        if (MembershipLevelCollections.data && MembershipLevelCollections.data.success) {
          this.success.getMembershipLevelCollections(MembershipLevelCollections);
        }
        if ($state.params) {
          this.handleEditViewMode();
          this.handleAuxilaryOptions();
          this.handleGroupTypeToggle();
        }        
        
        $scope.$emit('Application::contentTitleChange', {
          title: HelpersService.cap(this.mode) + ' Membership Level',
          buttonRight: {
            permissions: 'MEMBERSHIP_CATEGORY_CREATE',
            label: (this.isMode('edit')) ? 'Save' : 'Create & Continue',
            action: function() {
              $scope.membershipLevelsCreate.complete();
            }
          },
          buttonLeft: {
            label: 'Close',
            action: function() {
              $scope.membershipLevelsCreate.close();
            }
          }
        });
        
        $scope.$on('$destroy', $scope.$watch('membershipLevelsCreate.addOrgCardholder', this.onAddOrgCardholderUpdate));

        $scope.$on('upload::error', this.onUploadError);
        $scope.$on('upload::done', this.onUploadDone);
        $scope.$on('upload::add', this.onUploadAdd);
        
        $scope.$on('MembershipOfferings::Remove', this.onMembershipOfferingRemoved);
        $scope.$on('MembershipOfferings::Error', this.onMembershipOfferingError);

      },
      
      handleEditViewMode: function() {
        if ($state.params.categoryId) {
          this.mode = 'edit';
          this.getLevel($state.params.categoryId);
          this.categoryId = $state.params.categoryId;
        }
      },
      
      handleAuxilaryOptions: function () {
        if(this.company && this.company.auxiliaryMembership) {
          this.isAuxiliaryMembershipEnabled = this.company.auxiliaryMembership;
          if($state.params.auxiliary) {
            this.isRegular = false;
          }
          if ($state.params.groupId && !this.isMode('edit')) {
            this.setMembershipLevelCollection($state.params.groupId);
          }
        }
      },
      
      handleGroupTypeToggle: function() {
        switch ($state.params.group) {
          case 'organization':
            this.model.membershipLevelGroup = 'organization';
            break;
          case 'individualAndFamily':
            /* falls through */
          default:
            this.model.membershipLevelGroup = 'individualAndFamily';
            this.isGroupIndividualFamily = true;
        }
      },

      hasOfferings: function() {
        return (this.model.offerings instanceof Array && this.model.offerings.length);
      },

      isValidName: function() {

        var r = true;

        if (this.isSubmitted) {
          r = (this.model.name && this.model.name.replace(/\s/g, '').length > 0);
        }

        return r;
      },

      validate: function(publish) {
        var r;

        this.isSubmitted = true;
        this.notice.hideErrorMessages();
        this.notice.hideSuccessMessages();

        if (publish) {
          r = this.isValidName() && this.hasOfferings();
          if (!this.hasOfferings()) {
            this.notice.showErrorMessages([{
              message: 'Add offerings to publish membership level'
            }]);
          }
        }else{
          r = this.isValidName();
        }

        return r;
      },

      prepare: function() {
        var numberOfCardHolders = parseInt(this.numberOfCardHolders, 10);
        if (this.isGroupIndividualFamily === false) {
          this.model.membershipLevelGroup = 'organization';
          this.isRegular = true;
          if (this.addOrgCardholder) {
            this.model.rules.numberOfCardHolders = 1;
          } else {
            this.model.rules.numberOfCardHolders = (numberOfCardHolders > 0) ? numberOfCardHolders + 1 : 0;
          }
        } else if (this.isGroupIndividualFamily === true) {
          this.model.membershipLevelGroup = 'individualAndFamily';
          this.model.rules.numberOfCardHolders = numberOfCardHolders + 1;
        }
        if (!this.isRegular && this.selectedMembershipLevelCollection && this.selectedMembershipLevelCollection.id) {
          this.model.membershipLevelCollection = [this.selectedMembershipLevelCollection];
        } else {
          this.model.membershipLevelCollection = null;
        }
        this.model.auxiliary= !this.isRegular ;
      },

      create: function() {

        if (this.validate()) {

          this.model.state = 'draft';
          this.model.salesChannels = (new SalesChannelsFactory()).init();

          this.prepare();

          ApiService.membership.categories.create(this.model).then(this.success.create, this.error.create);

        }

      },

      update: function() {

        if (this.validate()) {

          if (!this.model.state) {
            this.model.state = 'draft';
          }

          this.prepare();

          ApiService.membership.categories.update(this.model).then(this.success.update, this.error.update);

        }
      },

      publish: function() {

        if (this.validate(true)) {

          if (!this.model.state) {
            this.model.state = 'draft';
          }

          this.prepare();

          ApiService.membership.categories.publish(this.model).then(this.success.publish, this.error.publish);

        }

      },

      isState: function(state) {
        return (this.model.state === state);
      },

      close: function() {
        var self = $scope.membershipLevelsCreate,
            data = {};
        if (!self.isRegular) {
          data.auxiliary = "1";
        }
        if (!self.isGroupIndividualFamily) {
          data.group = 'organization';
        }
        if (self.selectedMembershipLevelCollection && self.selectedMembershipLevelCollection.id) {
          data.groupId = self.selectedMembershipLevelCollection.id;
        }
        ViewStateService.setState('membership.levels', data);
        $state.go('application.membership.levels');
      },
      
      complete: function() {
        this.notice.hideErrorMessages();
        this.notice.hideSuccessMessages();

        if (this.isMode('edit')) {
          this.update();
        }else{
          this.create();
        }

      },

      save: function(publish) {

        if (this.isMode('edit')) {
          if (publish) {
            this.publish();
          }else {
            this.update();
          }
        }else{
          this.create();
        }

      },

      saveContinue: function() {
        this.create();
      },

      remove: function() {

        var self = $scope.membershipLevelsCreate;

        self.removeModal = $uibModal.open({
          templateUrl: 'views/application/views/membership/levels/create/modals/remove/remove.tpl.html',
          size: 'md',
          controller: 'MembershipLevelsCreateModalsRemoveController',
          resolve: {
            currentLevel: function() {
              return self.model;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.removeModal.result.then(function () {

          ApiService.membership.categories.remove({ id: self.model.id }).then(self.success.remove, self.error.remove);

        }, function () {
          // Do nothing
        });

      },

      isMode: function(mode) {
        return (this.mode === mode);
      },

      isTab: function(tab) {
        return (this.tab === tab);
      },

      getLevel: function(id) {
        ApiService.membership.categories.detail(id).then(this.success.getLevel, this.error.getLevel);
      },

      getTab: function(tab) {
        this.tab = tab;
      },

      checkShortDescription: function() {
        if (this.model.shortDescription) {
          this.model.shortDescription = this.model.shortDescription.replace(/[\s\n]+/g,' ');
          var len = HelpersService.getTextLength(this.model.shortDescription);

          if (len > this.descriptionMax) {
            this.model.shortDescription = this.model.shortDescription.substr(0, this.descriptionMax);
          }
        }else{
          this.model.shortDescription = '';
        }

        this.descriptionRemaining = this.descriptionMax - HelpersService.getTextLength(this.model.shortDescription);
      },

      showBenefits: function() {

        var self = $scope.membershipLevelsCreate;

        self.addModal = $uibModal.open({
          templateUrl: 'views/application/views/membership/benefits/modals/add/add.tpl.html',
          size: 'md',
          controller: 'MembershipBenefitsModalsAddController',
          resolve: {
            editable: function () {
              return true;
            },
            currentBenefits: function() {
              return self.model.benefits;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.addModal.result.then(function (benefits) {

          self.model.benefits = benefits;

        }, function () {
          // Do nothing
        });

      },

      findMembershipLevelCollection: function(id, force) {
        var i, ii,
            r = false,
            self = $scope.membershipLevelsCreate;
      
        for (i=0,ii=self.membershipLevelCollection.length;i<ii;i++) {
          if (self.membershipLevelCollection[i].id === id) { 
            r = {
              membershipLevelCollectionItem: self.membershipLevelCollection[i],
              index: i
            };
            break;
          }
        }
        
        return r;
      },

      setMembershipLevelCollection: function(id) {
        var found;
        
        found = this.findMembershipLevelCollection(id);
        if (found) {
          this.selectedMembershipLevelCollection = found.membershipLevelCollectionItem;
        }
      },

      process: function(level) {
        if (level.rules.numberOfCardHolders > 0) {
          if (level.rules.numberOfCardHolders === 1 && level.membershipLevelGroup === 'organization') {
            this.addOrgCardholder = true;
          } else {
            this.numberOfCardHolders = (parseInt(level.rules.numberOfCardHolders, 10) - 1);
          }
        } else {
          this.numberOfCardHolders = 0;
        }

        if (level.lastPublishedAt) {
          this.lastPublished = $filter('date')(CalendarService.parseDate(level.lastPublishedAt), this.dateFormat) + ' at ' + $filter('date')(CalendarService.parseDate(level.lastPublishedAt), this.hourFormat);
        }

        if (level.lastUpdatedAt) {
          this.lastUpdated = $filter('date')(CalendarService.parseDate(level.lastUpdatedAt), this.dateFormat) + ' at ' + $filter('date')(CalendarService.parseDate(level.lastUpdatedAt), this.hourFormat);
        }

        this.isRegular = !level.auxiliary;
        this.isGroupIndividualFamily = (level.membershipLevelGroup === 'individualAndFamily');
        
        if(level.membershipLevelCollection instanceof Array && level.membershipLevelCollection.length) {
          this.selectedMembershipLevelCollection = level.membershipLevelCollection[0];
        } else if ($state.params.groupId) {
          this.setMembershipLevelCollection($state.params.groupId);
        }

        return level;
      },

      removePhoto: function() {
        this.model.images = [];
      },

      success: {
        init: function(response) {},

        create: function(response) {
          var self = $scope.membershipLevelsCreate;
          self.isSubmitted = false;
          $state.go('application.membership.levels.edit', { categoryId: response.data.payload.id });
        },

        update: function(response) {
          var self = $scope.membershipLevelsCreate;

          self.model = self.process(response.data.payload);
          self.isSubmitted = false;
          self.notice.showSuccessMessages([
            { message: 'Successfully updated.' }
          ]);

          $timeout(function() {
            self.notice.hideSuccessMessages();
          }, 3000);
        },

        publish: function(response) {
          var self = $scope.membershipLevelsCreate;

          self.model = self.process(response.data.payload);
          self.isSubmitted = false;

          self.notice.showSuccessMessages([
            { message: 'Successfully published.' }
          ]);

          $timeout(function() {
            self.notice.hideSuccessMessages();
          }, 3000);
        },

        remove: function(response) {
          var self = $scope.membershipLevelsCreate;
          self.isSubmitted = false;
          self.close();
        },

        getLevel: function(response) {
          var self = $scope.membershipLevelsCreate;
          self.model = self.process(response.data.payload);
          
          $scope.$broadcast('MembershipOfferings::Update', { offerings: self.model.offerings });
        },
        
        getMembershipLevelCollections: function (response) {
          var self = $scope.membershipLevelsCreate;
          self.membershipLevelCollection = response.data.payload.list;       
        }
      },

      error: {
        init: function(response) {},
        generic: function(response) {
          var self = $scope.membershipLevelsCreate;
          self.isSubmitted = false;
          self.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },
        create: function(response) {
          $scope.membershipLevelsCreate.error.generic(response);
        },
        update: function(response) {
          $scope.membershipLevelsCreate.error.generic(response);
        },
        publish: function(response) {
          $scope.membershipLevelsCreate.error.generic(response);
        },
        remove: function(response) {
          $scope.membershipLevelsCreate.error.generic(response);
        },
        getLevel: function(response) {
          $scope.membershipLevelsCreate.error.generic(response);
        },
        getMembershipLevelCollections: function (response) {
          $scope.membershipLevelsCreate.error.generic(response);
        }
      },

      onUploadDone: function(e, data) {
        var self = $scope.membershipLevelsCreate;
        self.notice.hideErrorMessages();
        self.profileImageUploadStatus = 'Change';
        self.isLoadingImage = false;

        if (!(self.model.images instanceof Array)) {
          self.model.images = [];
        }

        self.model.images = [{
          id: data.file.uuid,
          extension: data.file.extension,
          highRes: data.file.highResPath,
          original: data.file.originalPath,
          preview: data.file.previewPath,
          screen: data.file.screenPath,
          thumbnail: data.file.thumbnailPath,
          uuid: data.file.uuid
        }];

        $scope.$apply();


      },

      onUploadError: function(e, data) {
        $scope.membershipLevelsCreate.notice.showErrorMessages([
          {
            message: data.result.error || 'There was a problem uploading that file.'
          }
        ]);
      },

      onUploadAdd: function(e, data) {

        var self = $scope.membershipLevelsCreate;

        self.notice.hideErrorMessages();

        self.isLoadingImage = true;
        self.profileImageUploadStatus = 'Uploading...';
        self.model.images = [];
      },

      onAddOrgCardholderUpdate: function(n, o) {
        var self = $scope.membershipLevelsCreate;

        if (n) {
          self.numberOfCardHolders = 0;
        }
      },

      onMembershipOfferingRemoved: function(e, data) {
        var self = $scope.membershipLevelsCreate;
        if (self.isMode('edit') && $state.params.categoryId) {
            self.getLevel($state.params.categoryId);
        }
      },

      onMembershipOfferingError: function(e, data) {
        var self = $scope.membershipLevelsCreate;
        if (data) {
           self.error.generic(data);
        }
      }


    };

    $scope.membershipLevelsCreate.init();

}]);